import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { compose } from "redux";
import { createHashHistory } from "history";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import { get_city_details } from "../../redux/actions/countryCityActions";
import "../../style/cityAndCountry/cityStateCountryDetails.scss";
import isEmpty from "lodash.isempty";

const history = createHashHistory();
class cityStateCountryDetails extends Component {
  constructor(props) {
    const viewLink = (props.match && props.match.params) && `CityStateCountryDetails/${props.match.params.cityId}`
    super(props);
    this.state = {
      cityDetails: {},
      alertMessage: "",
      msgType: "success",
      show: false,
      path: ["Home", "Cities", "View Details"],
      links: ["home","cityAndCountry",viewLink],
      isLoading: false
    };
  }

  componentWillMount() {
    let cityIdParams = this.props.match.params.cityId
      ? this.props.match.params.cityId
      : "";
    if (cityIdParams !== "") {
      this.props.get_city_details(cityIdParams);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.cityDetails !== nextProps.cityDetails &&
      !isEmpty(nextProps.cityDetails)
    ) {
      this.setState({ cityDetails: nextProps.cityDetails.data });
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true
      });
    }
    if (this.props.fetchCity !== nextProps.fetchCity) {
      this.setState({ isLoading: nextProps.fetchCity });
    }
  }

  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  render() {
    let cityRow;
    if (Object.getOwnPropertyNames(this.state.cityDetails).length !== 0) {
      cityRow = Object.keys(this.state.cityDetails).map(key => (
        <Row key={key}>
          <Col md={4}>
            <label className="titles-name">{key !== "cityID" && key}</label>
          </Col>
          <Col md={8}>
            <p>{key !== "cityID" && this.state.cityDetails[key]}</p>
          </Col>
          <div className="clearfix" />
        </Row>
      ));
    }
    return (
      <div>
        {Object.getOwnPropertyNames(this.state.cityDetails).length !== 0 ? (
          <div className="col-lg-12 cityStateCountryDetails">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
            <div className="panel">
              <header className="panel-heading">Manage Cities</header>
              <div className="panel-body">
                {cityRow}
                <br />
                <Button
                  bsStyle="info"
                  onClick={() => history.push(`/cityAndCountry`)}
                >
                  Go Back
                </Button>
                <div className="clearfix" />
              </div>
            </div>
          </div>
        ) : (
          this.state.show &&
          this.state.alertMessage !== "" && (
            <div className="col-lg-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong className="alert-msg-type">
                  {this.state.msgType}:
                </strong>{" "}
                {this.state.alertMessage}
              </Alert>
            </div>
          )
        )}
        {this.state.isLoading ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  cityDetails: state.countryCityReducers.cityDetails,
  error: state.countryCityReducers.error,
  fetchCity: state.countryCityReducers.fetchCity
});

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { get_city_details })
)(cityStateCountryDetails);



// WEBPACK FOOTER //
// ./src/app/views/cityAndCountry/cityStateCountryDetails.js